import React from 'react';
import { Form } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import { rem } from 'polished';

import { required } from 'helpers/validators';
import FormActionButtons from 'components/FormActionButtons/FormActionButtons';
import BasicModal from 'components/GenericModal/BasicModal';
import GenericText from 'components/GenericText/GenericText';
import { GenericTitle, TitleMargin } from 'components/GenericTitle/GenericTitle';
import GenericTitleSummary from 'components/GenericTitleSummary/GenericTitleSummary';
import Margin from 'components/Margin/Margin';
import LandingApp from 'LandingApp';

import { AuthInputField } from '../components/AuthInputField/AuthInputField';
import LandingButton from '../components/LandingButton/LandingButton';
import { Column, Grid, PageContents } from '../styled';
import ForgotPasswordPageContainer, { RenderProps } from './ForgotPasswordPageContainer';
import type { Values } from './types';

export type Props = RenderProps;

const ForgotPasswordPage = ({
  onSubmit,
  onCloseModal,
  onGoToHomePage,
  isSuccessModalOpen,
}: Props) => (
  <LandingApp>
    <PageContents>
      <Grid>
        <Column>
          <GenericTitle marginBottom={TitleMargin.Lg}>
            <FormattedMessage id="registration.forgotPasswordPage.title" />
          </GenericTitle>

          <GenericTitleSummary hasMarginBottomLg>
            <FormattedMessage id="registration.forgotPasswordPage.summary" />
          </GenericTitleSummary>

          <Form<Values>
            onSubmit={onSubmit}
            render={({ handleSubmit, submitting, values }) => (
              <>
                <form onSubmit={handleSubmit}>
                  <AuthInputField
                    name="email"
                    type="email"
                    text="registration.forgotPasswordPage.label"
                    disabled={submitting}
                    validate={required}
                  />

                  <LandingButton
                    text="registration.forgotPasswordPage.submit"
                    isDisabled={submitting}
                  />
                </form>

                <BasicModal width={rem(580)} isOpen={isSuccessModalOpen} onClose={onCloseModal}>
                  <BasicModal.Content>
                    <Margin top={30}>
                      <FormattedMessage
                        id="registration.forgotPasswordPage.modalSuccessMsg"
                        values={{
                          submittedEmail: values.email,
                          p: (chunks: React.ReactNode) => (
                            <GenericText hasMarginBottomSm>{chunks}</GenericText>
                          ),
                        }}
                      />
                    </Margin>
                  </BasicModal.Content>

                  <BasicModal.Footer>
                    <FormActionButtons
                      submitBtnContent={
                        <FormattedMessage id="registration.forgotPasswordPage.backToLogin" />
                      }
                      onSubmitBtnClick={onGoToHomePage}
                      isLabelHidden
                      hasNoMarginTop
                    />
                  </BasicModal.Footer>
                </BasicModal>
              </>
            )}
          />
        </Column>
      </Grid>
    </PageContents>
  </LandingApp>
);

export { ForgotPasswordPage as ForgotPasswordPageUnwrapped };

const render = (renderProps: RenderProps) => <ForgotPasswordPage {...renderProps} />;
export default () => <ForgotPasswordPageContainer render={render} />;
